import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader, Tab, AppBar, Tabs } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import MaterialBox from "../../components/MaterialBox";
import { DesignationContext } from "../../context/designationcontext";

const WFHManagemnt = () => {
  const navigate = useNavigate();
  const { user, AccessData, HRRole, setHRRole, Manager, setManager } =
    useContext(UserDetailsContext);

  const tablist = JSON.parse(sessionStorage.getItem("WFHApp"));

  let MainValue;

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "HrApproval" && item.can_access
    )
  ) {
    if (tablist === "HR") {
      MainValue = "HR";
    } else if (tablist === "HRList") {
      MainValue = "HRList";
    } else {
      MainValue = "Employee";
    }
  }
  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "ManagerApproval" && item.can_access
    )
  ) {
    if (tablist === "ManagerList") {
      MainValue = "ManagerList";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    !AccessData.some(
      (item) =>
        item.component === "ManagerApproval" || item.component === "HrApproval"
    )
  ) {
    MainValue = "Employee";
  }

  const [tabValue, setTabValue] = useState(MainValue);

  const { handleClearSelection } = useContext(DesignationContext);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const id = user?.id;
  // const [HRRole, setHRRole] = useState(false);
  // const [Manager, setManager] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [wfhList, setWfhList] = useState([]);
  // console.log('wfhListwfhList:',wfhList);
  const statusColors = {
    Approved: "#27ae60",
    Rejected: "#e74c3c",
    Pending: "#f39c12",
  };
  const wfhListTable = {
    columns: [
      {
        field: "firstName",
        headerName: "User Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //     field: "requestedDate",
      //     headerName: "Requested Date",
      //     flex: 1,
      //     editable: false,
      //     disableColumnMenu: true,
      //     sortable:true,
      // },
      {
        field: "startDate",
        headerName: "Start Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "endDate",
        headerName: "End Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "totalDays",
        headerName: "Total Days",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "reason",
        headerName: "Reason",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "Allstatus",
        headerName: "Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: wfhList
      .map((wfh, index) => ({
        id: wfh.id,

        firstName: wfh.user.firstName?.toUpperCase(),
        requestedDate: wfh.requestedDate,
        startDate: wfh.startDate,
        endDate: wfh.endDate,
        totalDays: wfh.totalDays,
        reason: wfh.reason,
        teamApproval: wfh.teamApproval
          ? wfh.teamApproval?.charAt(0).toUpperCase() +
            wfh.teamApproval?.slice(1)
          : "",
        hrApproval: wfh.hrApproval
          ? wfh.hrApproval?.charAt(0).toUpperCase() + wfh.hrApproval?.slice(1)
          : "",

        Allstatus:
          wfh.status == "pending"
            ? wfh.approvalStatus !== null
              ? "Pending By " +
                wfh.approvalStatus?.approver?.firstName +
                " " +
                wfh.approvalStatus?.approver?.lastName
              : wfh?.hrApproval == "pending"
              ? "Pending By Hr"
              : "Approved By Hr"
            : wfh.status == "rejected"
            ? "Rejected"
            : wfh.status == "approved"
            ? "Approved"
            
             : wfh.status == "Cancelled"
            ? "Cancelled":"",
        status: wfh.status?.charAt(0).toUpperCase() + wfh.status?.slice(1),
      })),
  };
  useEffect(() => {
    getteamleadeID();
    const tabName = JSON.parse(sessionStorage.getItem("WFHApp"));

if(tabName){
  setTabValue(tabName);
}else{
  setTabValue("Employee");
}

  }, []);

  const [TeamLeaderID, setTeamLeaderID] = useState([]);

  const getteamleadeID = async () => {
    const query = `  
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      department
      firstName
      lastName
      
    }
  }
}
`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsedddddddd:", response.data);

      const managerList = response.data.data.allManagers;
      const filterdata = managerList.filter(
        (val) => val.user.empid == user.empid
      );
      let dataid = filterdata[0]?.user?.id;
      localStorage.setItem("reqteam", dataid);
      setTeamLeaderID(filterdata);
      console.log("filterdatafilterdata:", filterdata);

      // setManagerList(managerList);
      // setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", managerList);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };
  const handleNewWfh = () => {
    navigate("/WFH-Management/add-WFH");
  };
  const onWfhListClick = (e) => {
    console.log("eventssss:", e);
    if (tabValue == "HR") {
      navigate(`/WFH-Management/WFHApproval?id=${e?.id}`);
      return;
    } else if (tabValue == "HRList") {
      navigate(`/WFH-Management/WFHApproval?id=${e?.id}`);
      return;
    } else if (tabValue == "Manager") {
      navigate(`/WFH-Management/WFHApproval?id=${e?.id}`);
      return;
    } else if (tabValue == "ManagerList") {
      navigate(`/WFH-Management/WFHApproval?id=${e?.id}`);
      return;
    } else if (
      e.row.hrApproval == "Approved" ||
      e.row.teamApproval == "Approved" ||
      e.row.status == "Approved"
    ) {
      navigate(`/WFH-Management/WFHViewScreen?id=${e?.id}`);
      return;
    } else {
      navigate(`/WFH-Management/WFH-details?id=${e?.id}`);
    }

    if (
      e.row.hrApproval == "Pending" &&
      e.row.teamApproval == "Approved" &&
      e.row.status == "Pending"
    ) {
      console.log("Correct");

      navigate(`/WFH-Management/WFHViewScreen?id=${e?.id}`);
      return;
    }
    if (
      e.row.hrApproval == "Pending" &&
      e.row.teamApproval == "Rejected" &&
      e.row.status == "Rejected"
    ) {
      console.log("Correct");

      navigate(`/WFH-Management/WFHViewScreen?id=${e?.id}`);
      return;
    }

    // console.log('onWfhListClick:', e?.id, e);
    // if (e?.id) {
    //     navigate(`/WFH-Management/wfh-details?id=${e?.id}`);
    // }
  };
  //   const onWfhSubmit = async () => {};

  const handleSetTabValue = (event, newValue) => {
    console.log("event:", event.target.value);
    if (newValue == "HR") {
      setHRRole(true);
      sessionStorage.setItem("WFHApp", JSON.stringify(newValue));
    } else if (newValue == "Manager") {
      setManager(true);
    } else if (newValue == "HRList") {
      sessionStorage.setItem("WFHApp", JSON.stringify(newValue));
    } else if (newValue == "ManagerList") {
      sessionStorage.setItem("WFHApp", JSON.stringify(newValue));
    } else if (newValue == "Employee") {
      sessionStorage.setItem("WFHApp", JSON.stringify(newValue));
    }
    setTabValue(newValue);
  };

  const submithandelar = async () => {
    handleClearSelection();
    if (tabValue == "HR") {
      const query = `
     query WfhRequestAllList{ 

  getWfhAll{ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

} 
            `;

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Extract department data from the response
        const wfhList = response.data.data.getWfhAll?.data;
        console.log("HRPendingList:", wfhList);

        setWfhList(wfhList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "HRList") {
      const query = `
 query WfhRequestListByTeamLeaderAll($id: String!){ 

  requestWfhDetailsTeamAll(id: $id){ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

} 

`;

      const encodedId = btoa(user?.id);
      let data = "VXNlck5vZGU6" + "" + encodedId;
      let reportnum = localStorage.getItem("reqteam");
      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: { id: reportnum },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const wfhList = response.data.data?.requestWfhDetailsTeamAll?.data;
        console.log("HRALL_LIST:", response.data);

        setWfhList(wfhList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "Manager") {
      const query = `
 query WfhRequestListByTeamLeader($id: String!){ 

  requestWfhDetailsTeam(id: $id){ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

} 

`;

      let reportnum = localStorage.getItem("reqteam");

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: { id: reportnum },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const wfhList = response.data.data.requestWfhDetailsTeam;

        setWfhList(wfhList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "ManagerList") {
      const query = `
 query WfhRequestListByTeamLeaderAll($id: String!){ 

  requestWfhDetailsTeamAll(id: $id){ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

} 

`;

      const encodedId = btoa(user?.id);
      let data = "VXNlck5vZGU6" + "" + encodedId;
      let reportnum = localStorage.getItem("reqteam");
      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: { id: reportnum },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const wfhList = response.data.data.requestWfhDetailsTeamAll?.data;

        setWfhList(wfhList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else {
      const query = `
   query WorkFromHomeRequestListByUserId($id: String!){ 

  userWfhDetails(id: $id){ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

} 

 
`;

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: { id: user?.id },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("response:", response.data);

        // Extract department data from the response
        const wfhList = response.data.data.userWfhDetails?.data;
        console.log("wfhList:", wfhList);

        setWfhList(wfhList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    }
  };
  useEffect(() => {
    submithandelar();
  }, [tabValue]);
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Work From Home List
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of WFH that you can get details of WFH.
                            </MaterialTypography> */}
              </Stack>
              <MaterialBox alignItems="center" width="60%">
                <MaterialBox width="80%">
                  <AppBar position="static">
                    <Tabs
                      orientation={tabsOrientation}
                      value={tabValue}
                      onChange={handleSetTabValue}
                      sx={{ backgroundColor: "transparent" }}
                    >
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.module ==="WFHManagement" &&
                            item.component === "HrApproval" && item.can_access
                        ) && <Tab label="HR List" value="HR" />}
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                          (
                            item.module ==="WFHManagement" &&
                            item.component === "HrApproval" && item.can_access) ||( item.module ==="WFHManagement" &&item.component === "ManagerApproval" &&
                            item.can_access)
                        ) && <Tab label="Team List" value="HRList" />}
                      {/* {AccessData &&
                                          Array.isArray(AccessData) &&
                                          AccessData.some(
                                            (item) =>
                                              item.component === "ManagerApproval" &&
                                              item.can_access
                                          ) && <Tab label="Employee" value="Manager" />} */}
                      {/* {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.component === "ManagerApproval" &&
                            item.can_access
                        ) && <Tab label="Team List" value="ManagerList" />} */}

                      <Tab label="My List" value="Employee" />
                    </Tabs>
                  </AppBar>
                </MaterialBox>
              </MaterialBox>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddWFH" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewWfh()}
                  >
                    WFH
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={wfhListTable.rows}
          customHeight={500}
          columns={wfhListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onWfhListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Work From Home found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Work From Home details. Click on
                  the "Add Work From Home" button to start adding Work From Home
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default WFHManagemnt;
